module.exports = __webpack_public_path__ + "static/media/wtw_new_logo_color.c7a2a39c.svg";